import React, { useState, useEffect } from 'react';
import { updateUser } from '../../api/utils';
import { Modal } from 'bootstrap';
import { getAccesstoken } from '../../utils/auth';

const EditPopup = ({ userData, closePopup }) => {
  const access_token = getAccesstoken();
  // Initialize formData with a check for address being properly structured
  const [formData, setFormData] = useState(() => {
    // Log the incoming userData to inspect the address structure
    
    const address = userData?.address || { street: '', state: '', pincode: '' };

    return {
      first_name: userData.first_name || '',
      last_name: userData.last_name || '',
      email: userData.email || '',
      mobile: userData.mobile || '',
      gender: userData.gender || 'male',
      address,
      id: userData.id,
      date_of_birth: userData.date_of_birth,
      profile_image: null // Add this to store file object
    };
  });

  useEffect(() => {
    // Initialize the modal
    const modalElement = document.getElementById('editProfileModal');
    const modal = new Modal(modalElement);
    modal.show();

    // Cleanup on component unmount
    return () => {
      modal.hide();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      address: {
        ...prevData.address,
        [name]: value, // Update specific field in address object
      },
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prevData => ({
      ...prevData,
      profile_image: file
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      
      // Append all text fields
      formDataToSend.append('first_name', formData.first_name);
      formDataToSend.append('last_name', formData.last_name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('mobile', formData.mobile);
      formDataToSend.append('gender', formData.gender);
      formDataToSend.append('date_of_birth', formData.date_of_birth);
      formDataToSend.append('address', JSON.stringify(formData.address));

      // Append file if it exists
      if (formData.profile_image) {
        formDataToSend.append('profile_image', formData.profile_image);
      }

      await updateUser(formData.id, formDataToSend, access_token);
      closePopup();
      window.location.reload();
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  return (
    <div className="modal fade" id="editProfileModal" tabIndex="-1" aria-labelledby="editProfileModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="editProfileModalLabel">Edit Profile</h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={closePopup}
              aria-label="Close"
            ></button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label className="col-form-label">First Name:</label>
                <input
                  type="text"
                  className="form-control"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Last Name:</label>
                <input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Email:</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Mobile:</label>
                <input
                  type="tel"
                  className="form-control"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Gender:</label>
                <select
                  name="gender"
                  className="form-control"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div className="form-group">
                <label className="col-form-label">Date of Birth:</label>
                <input
                  type="date"
                  className="form-control"
                  name="date_of_birth"
                  value={formData.date_of_birth}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Profile Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="form-control"
                />
              </div>
              
              {/* Address Fields */}
              <div className="form-group">
                <label className="col-form-label">Street Address:</label>
                <input
                  type="text"
                  className="form-control"
                  name="street_address"
                  value={formData.address.street_address  } // Directly use street from address
                  onChange={handleAddressChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">State:</label>
                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={formData.address.state} // Directly use state from address
                  onChange={handleAddressChange}
                  required
                />
              </div>
              <div className="form-group">
                <label className="col-form-label">Pincode:</label>
                <input
                  type="text"
                  className="form-control"
                  name="pincode"
                  value={formData.address.pincode} // Directly use pincode from address
                  onChange={handleAddressChange}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={closePopup}
              >
                Cancel
              </button>
              <button 
                type="submit"
                className="btn btn-animation-blue ms-2"
                style={{ 
                  backgroundColor: 'var(--theme-color)',
                  color: 'white',
                  border: 'none'
                }}
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Add these styles to your CSS
const styles = `
  .btn-animation-blue {
    background-color: var(--theme-color);
    color: white;
    border: none;
    padding: 8px 20px;
    transition: all 0.3s ease;
  }

  .btn-animation-blue:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  .modal-footer {
    border-top: 1px solid #dee2e6;
    padding: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .modal-content {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
`;

export default EditPopup;
